//Template 
jQuery(document).ready(function($) {
    
    function formatDCI (dci) {
      if (dci.loading) {
         return "Chargement ...";
      }
      var markup = "<div class='select2-result-dci'>" + dci.name + '</div>';
      return markup;
    }


    // $(document).on('keyup', '#dfg', function(event) {
    //   event.preventDefault();
    //   if (event.keyCode === 13) {
    //     $('#btn_submit_dfg').click();
    //   }
    // });

});

